import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import axios from '../plugins/axios'

Vue.use(VueRouter);

const route = (route, prefix = null, dynamic = false) => {
  const name = prefix ?
    route === 'index' ? prefix : `${prefix}-${route}` : route;

  const path = route === 'index' ? '/' : `${dynamic ? ':' + route : route}`;
  // const path = prefix ? route === 'index' ? '/' + prefix : '/' + prefix + '/' + route : route === 'index' ? '/' : `${dynamic ? ':' + route : prefix ? '/' + prefix + '/' + route : '/' + route}`;
  const component = prefix ? () => import(`../pages/${prefix.split('-').join('/')}/${route}`) : () => import(`../pages/${route}`);
  return {name, path, component};
};

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    route('index'),
    {
      path: '/jezici',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'jezici'),
        route('create', 'jezici'),
      ]
    },
    {
      path: '/meni',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'meni'),
        route('create', 'meni'),
        {
          path: ':id',
          component: () => import('../layouts/layout'),
          children: [
            {
              path: 'items',
              component: () => import('../layouts/layout'),
              children: [
                route('index', 'meni-id-items'),
                route('create', 'meni-id-items'),
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/korisnici',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'korisnici'),
        route('create', 'korisnici'),
        {
          path: 'roles',
          component: () => import('../layouts/layout'),
          children: [
            route('index', 'korisnici-roles'),
            route('create', 'korisnici-roles'),
          ]
        }
      ]
    },
    {
      path: '/stranice',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'stranice'),
        route('create', 'stranice')
      ]
    },
    {
      path: '/kategorije',
      component: () => import('../layouts/layout'),
      children: [
        route('dokumenti', 'kategorije'),
        route('objekti', 'kategorije'),
        route('stranice', 'kategorije'),
        route('vijesti', 'kategorije'),
        route('kompanije', 'kategorije'),
        route('create', 'kategorije')
      ]
    },
    {
      path: '/dokumenta',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'dokumenta'),
        route('create', 'dokumenta')
      ]
    },
    {
      path: '/objekti',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'objekti'),
        route('create', 'objekti'),
      ]
    },
    {
      path: '/fotografije',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'fotografije'),
        route('create', 'fotografije')
      ]
    },
    {
      path: '/video',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'video'),
        route('create', 'video')
      ]
    },
    {
      path: '/vijesti',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'vijesti'),
        route('create', 'vijesti'),
      ]
    },
    {
      path: '/proizvodi',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'proizvodi'),
        route('create', 'proizvodi'),
      ]
    },
    {
      path: '/logovanje',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'logovanje'),
      ]
    },
    {
      path: '/profil',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'profil'),
      ]
    },
    {
      path: '/sajtovi',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'sajtovi'),
        route('create', 'sajtovi'),
      ]
    },
    {
      path: '/settings',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'settings'),
        //route('create', 'sajtovi'),
      ]
    },
    {
      path: '/kompanije',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'kompanije'),
        route('create', 'kompanije'),
      ]
    },
    {
      path: '/narudzbine',
      component: () => import('../layouts/layout'),
      children: [
        route('index', 'narudzbine'),
        {
          path: ':id',
          component: () => import('../layouts/layout'),
          children: [
            {
              path: 'proizvodi',
              component: () => import('../layouts/layout'),
              children: [
                route('index', 'narudzbine-id-proizvodi')
              ]
            }
          ]
        }
      ]
    },
    {
    	path: '/distribucija/gradovi/create',
			name: 'distribucija-gradovi-create',
			component: () => import('../pages/distribucija/gradovi/create')
		},
    {
    	path: '/distribucija/gradovi/index',
			name: 'distribucija-gradovi',
			component: () => import('../pages/distribucija/gradovi/index')
    },
    {
      path: '/distribucija/prodavci/create',
      name: 'distribucija-prodavci-create',
      component: () => import('../pages/distribucija/prodavci/create')
    },
    {
      path: '/distribucija/prodavci/index',
      name: 'distribucija-prodavci',
      component: () => import('../pages/distribucija/prodavci/index')
    },
    {
      path: '/distribucija/distributeri/create',
      name: 'distribucija-distributeri-create',
      component: () => import('../pages/distribucija/distributeri/create')
    },
    {
      path: '/distribucija/distributeri/index',
      name: 'distribucija-distributeri',
      component: () => import('../pages/distribucija/distributeri/index')
    },
    {
      path: '/distribucija/udruzenja/create',
      name: 'distribucija-udruzenja-create',
      component: () => import('../pages/distribucija/udruzenja/create')
    },
    {
      path: '/distribucija/udruzenja/index',
      name: 'distribucija-udruzenja',
      component: () => import('../pages/distribucija/udruzenja/index')
    },
    {
      path: '/forms/index',
      name: 'forme',
      component: () => import('../pages/forms/index')
    },
    {
      path: '/vijesti-nova',
      name: 'vijesti-nova',
      component: () => import('../pages/vijesti/indexNew')
    },
    {
      path: '/surveys/index',
      name: 'surveys',
      component: () => import('../pages/surveys/index')
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (!store.state.user && localStorage.getItem('bitlab-token') && to.name !== 'logovanje') {
    axios.get('/user/me').then(res => {
      store.commit('SAVE_USER', res.data)
      store.commit('SAVE_SITE', res.data.website[0])
    }).then(() => {
      //samo za super admina
      if (to.name === 'sajtovi' || to.name === 'korisnici') {
        if (store.state.user.type === 1) {
          next()
        }
        else {
          next({name: 'index'})
        }
      }
      else {
        next()
      }
    })
  }
  else if (localStorage.getItem('bitlab-token') && to.name !== 'logovanje') {
    next();
  }
  else if (to.name !== 'logovanje') {
    next({name: 'logovanje'})
  }
  else {
    //samo za super admina
    if (to.name === 'sajtovi' || to.name === 'korisnici') {
      if (store.state.user.type === 1) {
        next()
      }
      else {
        next({name: 'index'})
      }
    }
    else {
      next()
    }
  }
})

export default router
